// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"ChoosePasswordPage_pageWrapper__3DivK"};